import { Controller } from "stimulus";
import Splide from "@splidejs/splide";

export default class extends Controller {

  initialize() {
    const styles = getComputedStyle(this.element);
    const breakpoints = {
      oneItem: styles.getPropertyValue('--one-item-breakpoint'),
      twoItem: styles.getPropertyValue('--two-item-breakpoint'),
      threeItem: styles.getPropertyValue('--three-item-breakpoint')
    };
    const gap = styles.getPropertyValue('--gap');
    // Desktop per-page follows the block's column count via the --per-page custom property.
    const perPage = parseInt(styles.getPropertyValue('--per-page'), 10) || 3;

    this.slider = new Splide(this.element, {
      gap: gap,
      perPage: perPage,
      perMove: 1,
      pagination: false,
      arrows: true,
      speed: 600,
      waitForTransition: false,
      breakpoints: {
        [breakpoints.oneItem]: { perPage: 1 },
        [breakpoints.twoItem]: { perPage: 2 },
        [breakpoints.threeItem]: { perPage: Math.min(perPage, 3) }
      }
    }).mount();

    document.dispatchEvent(new CustomEvent('NewSplideInstance', { detail: { 'splideElement': this.element } }));
  }
};
